export type Option<T = string> = {
  label: string;
  value: T;
};

export type HexColor = `#${string}`;

export const IconNames = {
  activityFeed: "activityFeed",
  add: "add",
  automation: "automation",
  appointment: "appointment",
  bell: "bell",
  bellOff: "bellOff",
  bidirectional: "bidirectional",
  calendar: "calendar",
  car: "car",
  card: "card",
  chevronDown: "chevronDown",
  chevronUp: "chevronUp",
  chevronLeft: "chevronLeft",
  chevronRight: "chevronRight",
  circle: "circle",
  circleCheck: "circleCheck",
  check: "check",
  customerUpdate: "customerUpdate",
  clear: "clear",
  clearFilters: "clearFilters",
  clipboard: "clipboard",
  clipboardCheck: "clipboardCheck",
  clock: "clock",
  clockDown: "clockDown",
  clockUp: "clockUp",
  clockFade: "clockFade",
  clockAdd: "clockAdd",
  clockWarn: "clockWarn",
  container: "container",
  dashboard: "dashboard",
  delete: "delete",
  dollarSign: "dollarSign",
  downArrow: "downArrow",
  duplicate: "duplicate",
  download: "download",
  dueIn: "dueIn",
  dueOut: "dueOut",
  edit: "edit",
  editLine: "editLine",
  editSquare: "editSquare",
  employees: "employees",
  filters: "filters",
  featureFlags: "featureFlags",
  globalFeatureFlags: "globalFeatureFlags",
  grid: "grid",
  inbox: "inbox",
  info: "info",
  jobs: "jobs",
  integration: "integration",
  layouts: "layouts",
  leftArrow: "leftArrow",
  list: "list",
  loader: "loader",
  lock: "lock",
  login: "login",
  logout: "logout",
  message: "message",
  messages: "messages",
  metrics: "metrics",
  minimize: "minimize",
  moreVertical: "moreVertical",
  moreHorizontal: "moreHorizontal",
  number: "number",
  open: "open",
  panelLeft: "panelLeft",
  panelLeftClose: "panelLeftClose",
  panelRight: "panelRight",
  panelRightClose: "panelRightClose",
  phone: "phone",
  print: "print",
  question: "question",
  rightArrow: "rightArrow",
  rotateCw: "rotateCw",
  rotateCcw: "rotateCcw",
  save: "save",
  search: "search",
  settings: "settings",
  shop: "shop",
  sort: "sort",
  support: "support",
  sync: "sync",
  tag: "tag",
  tags: "tags",
  undo: "undo",
  upload: "upload",
  upArrow: "upArrow",
  user: "user",
  users: "users",
  waiter: "waiter",
  warning: "warning",
  x: "x",
  folderOpen: "folderOpen",
  plus: "plus",
  gripVertical: "gripVertical",
  barChart: "barChart",
  alertTriangle: "alertTriangle",
  userCheck: "userCheck",
  checkCircle: "checkCircle",
  move: "move",
  promiseTime: "promiseTime",
  linkedLabel: "linkedLabel",
  cardCreatedTrigger: "cardCreatedTrigger",
  cardMovedIntoContainer: "cardMovedIntoContainer",
  cardMovedOutOfContainer: "cardMovedOutOfContainer",
  cardChangesToWaiter: "cardChangesToWaiter",
  cardChangesToDropOff: "cardChangesToDropOff",
  whenPromiseTimeDue: "whenPromiseTimeDue",
  whenScheduledTimeOccurs: "whenScheduledTimeOccurs",
  isWaiter: "isWaiter",
  isDropOff: "isDropOff",
  containerNameIs: "containerNameIs",
  technicianNameIs: "technicianNameIs",
  serviceAdvisorNameIs: "serviceAdvisorNameIs",
  estimatedLaborGreater: "estimatedLaborGreater",
  estimatedLaborLess: "estimatedLaborLess",
  vehicleMakeIs: "vehicleMakeIs",
  resetAutomated: "resetAutomated",
  wiggleCard: "wiggleCard",
  setCardColor: "setCardColor",
  wiggleAndSetCardColor: "wiggleAndSetCardColor",
  flashColor: "flashColor",
  changeCardColor: "changeCardColor",
  createCustomerUpdate: "createCustomerUpdate",
  createATask: "createATask",
  showAToast: "showAToast",
  startATimer: "startATimer",
  stopATimer: "stopATimer",
  resetATimer: "resetATimer",
  addTags: "addTags",
  removeTags: "removeTags",
} as const;

export type IconNames = (typeof IconNames)[keyof typeof IconNames];
